import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";

const API = process.env.REACT_APP_BACKEND_URL;

export default function StrategiaSlide() {
  const { n } = useParams();
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/public/strategia-balneare").then((r) => setD(r.data)).catch(() => {}); }, []);
  const sl = d?.slides?.[Number(n)];
  if (!sl) return <div className="min-h-screen bg-[#0B1220]" />;
  return (
    <div className="min-h-screen bg-[#0B1220] text-white px-16 py-14 grid grid-cols-[1fr_1.1fr] gap-12 items-center" data-testid="strategia-slide">
      <div>
        <p className="text-sm font-semibold tracking-[0.3em] uppercase text-[#38BDF8]">{sl.sezione}</p>
        <h1 className="font-heading text-5xl font-semibold leading-[1.05] mt-4">{sl.titolo}</h1>
        <ul className="mt-8 space-y-3">{sl.punti.map((p, i) => <li key={i} className="flex items-start gap-3 text-xl text-white/90"><span className="mt-2 h-2.5 w-2.5 rounded-full bg-[#0070BA] shrink-0" />{p}</li>)}</ul>
        <p className="mt-10 text-sm text-white/50">BeAIchy · un progetto di Casa Energia Green · {Number(n) + 1}/{d.slides.length}</p>
      </div>
      <div className="rounded-3xl bg-white p-5 shadow-2xl">
        {sl.chart ? <img src={`${API}/api/public/strategia-balneare/grafico/${sl.chart}.png`} alt={sl.titolo} className="w-full rounded-2xl" /> :
          <div className="grid grid-cols-2 gap-3">{(sl.key === "pacchetti" ? d.pacchetti.map((p) => ({ t: p.nome, s: p.pratiche })) : sl.key === "partnership" ? d.partnership.map((p) => ({ t: p.nome, s: p.durata })) : sl.key === "care" ? d.care.kpi.map((k) => ({ t: k, s: "obiettivo" })) : sl.punti.slice(0, 6).map((p) => ({ t: p.split(":")[0], s: p.split(":").slice(1).join(":") || " " }))).map((c, i) => <div key={i} className="rounded-2xl bg-slate-50 border border-slate-200 p-4"><div className="font-heading text-lg font-semibold text-[#003087] leading-tight">{c.t}</div><div className="text-sm text-slate-600 mt-1">{c.s}</div></div>)}</div>}
      </div>
    </div>
  );
}
